import React from "react";

import colors from "../../styles/colors";

export default (props) => {
  return (
    <div
      style={{
        borderColor: colors.primary,
        backgroundColor:
          props.rating !== props.value ? colors.lightGrey : colors.orange,
        border: "solid 2px",
        height: 50,
        width: 50,
        borderRadius: 7,
        justifyContent: "center",
        alignItems: "center",
        backgroundImage: `url(${props.img})`,
        backgroundSize: "contain",
        boxShadow: "4px 4px 7px -1px rgba(0,0,0,0.32)",
      }}
      onClick={() => {
        props.setRating(props.value);
      }}
    />
  );
};



// WEBPACK FOOTER //
// ./src/components/survey/FaceButton.js